var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { WMLogger } from '@mobilize/logging';
import { Model } from './Model';
import { Dictionary } from '../Application';
import { ErrorCodes, ExceptionHandlerClass } from '../System/Aop';
import { Messages } from '../System/Diagnostics';
var ModelCollection = (function () {
    function ModelCollection() {
        this.models = new Dictionary();
        this.removedModels = [];
    }
    ModelCollection.prototype.add = function (model) {
        if (this.models.containsKey(model.UniqueID)) {
            if (this.models.value(model.UniqueID).IsTempModel) {
                this.models.remove(model.UniqueID);
            }
            else {
                throw new Error("there is a problem, can't add a repeated uniqueID into the model collection.");
            }
        }
        this.models.add(model.UniqueID, model);
    };
    ModelCollection.prototype.apply = function (fn) {
        if (fn) {
            this.models.values().forEach(function (item) { return fn(item); });
        }
    };
    ModelCollection.prototype.getModel = function (key) {
        if (this.models.containsKey(key)) {
            return this.models.value(key);
        }
        WMLogger.instance().error(Messages.Error.ModelNotFound, { id: key });
        return null;
    };
    ModelCollection.prototype.getParentByKey = function (key) {
        var parentUniqueID = key.substr(key.indexOf(Model.separator) + Model.separator.length);
        return this.getModel(parentUniqueID);
    };
    ModelCollection.prototype.getParentByModel = function (model) {
        return this.getParentByKey(model.UniqueID);
    };
    ModelCollection.prototype.addRange = function (array) {
        var _this = this;
        array.forEach(function (element) {
            _this.add(element);
        });
    };
    Object.defineProperty(ModelCollection.prototype, "length", {
        get: function () {
            return this.models.length;
        },
        enumerable: false,
        configurable: true
    });
    ModelCollection.prototype.deleteCascade = function (key) {
        var model = this.getModel(key);
        if (model) {
            for (var propertyName in model) {
                if (this.isValidModelProperty(model, propertyName)) {
                    this.removePointer(propertyName, key);
                }
            }
            this.removedModels.push(key);
            this.models.remove(key);
        }
    };
    ModelCollection.prototype.removePointer = function (propertyName, key) {
        propertyName = propertyName === 'Items' ? '_items' : propertyName;
        var pointerName = propertyName + Model.separator + key;
        this.deleteCascade(pointerName);
    };
    ModelCollection.prototype.isValidModelProperty = function (model, propertyName) {
        return (model.hasOwnProperty(propertyName) && model[propertyName] && model[propertyName].UniqueID);
    };
    ModelCollection.prototype.replace = function (model) {
        this.models.replace(model.UniqueID, model);
    };
    ModelCollection.prototype.switchIds = function (oldUniqueId, newUniqueId) {
        var model = this.models.value(oldUniqueId);
        var tempModel = this.models.value(newUniqueId);
        if (model) {
            model.UniqueID = newUniqueId;
            this.models.remove(oldUniqueId);
            this.models.add(newUniqueId, model);
            var parentArray = this.getParentByKey(newUniqueId);
            if (parentArray && parentArray.isArray) {
                if (tempModel) {
                    tempModel.UniqueID = oldUniqueId;
                }
                else {
                    tempModel = new Model(oldUniqueId);
                }
                tempModel.IsTempModel = true;
                this.models.add(oldUniqueId, tempModel);
                var radix = 10;
                var oldIndex = parseInt(oldUniqueId.split(Model.separator)[0], radix);
                var newIndex = parseInt(newUniqueId.split(Model.separator)[0], radix);
                parentArray.splice(oldIndex, 1, tempModel);
                parentArray.splice(newIndex, 1, model);
            }
        }
    };
    ModelCollection.prototype.exists = function (model) {
        return this.models.containsKey(model.UniqueID) && !this.models.value(model.UniqueID).IsTempModel;
    };
    ModelCollection.prototype.search = function (name) {
        var model = null;
        this.models.values().forEach(function (item) {
            if (item && item.UniqueID && item.UniqueID.indexOf(name) > -1) {
                model = item;
            }
        });
        return model;
    };
    ModelCollection.prototype.toArray = function () {
        return this.models.values();
    };
    ModelCollection = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore),
        __metadata("design:paramtypes", [])
    ], ModelCollection);
    return ModelCollection;
}());
export { ModelCollection };
